import React from 'react';
import Component from '../../components/Component';
import DbInfo from '../../dbinfo';
import * as Constants from '../../constants';
import Toolbar from '../../components/Toolbar';
import {Button, DropdownButton, MenuItem} from 'react-bootstrap';
import {RxForm, FormManager, FormField, FormRow, Multiform} from 'reactis-forms';
import {
	TextInput,
	TextArea,
	DatePicker,
	RadioList,
	FileUpload,
	ImageUpload,
	Select,
	ToggleButton,
	Checkbox,
	Number
} from 'reactis-inputs';
import {actions as formactions} from 'reactis-forms';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';
import FormDB from '../../components/FormDB';
import {Loader, LoadingButton} from 'reactis-loader';
import ActionButton from '../../components/ActionButton';
import SaveButton from '../../components/SaveButton';
import ButtonToolbar from '../../components/ButtonToolbar';
import DriverLookup from '../../components/Form/DriverLookup';
import TrainingTypeSelect from "../../components/Form/TrainingTypeSelect";
import Client from "../../helpers/ApiClient";
import IconCheckbox from "../../components/Form/IconCheckbox";
import ClientLookup from "../../components/Form/ClientLookup";
import Reminders from "../../components/Form/Reminders";
import OrderLookup from "../../components/Form/OrderLookup";
import TableForm from "../../components/TableForm";

class ItemSubform extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			overRemove: false
		}
	}

	handleMouseOver() {
		this.setState({overRemove: true});
	}

	handleMouseOut() {
		this.setState({overRemove: false});
	}

	render() {
		return (
			<tr className={this.state.overRemove ? 'subformOverRemove' : null}>
				<td><FormField name="title"/></td>
				<td><FormField name="amount"/></td>
				<td><FormField name="price"/></td>
				<td><i title="Odstranit"
				       onClick={this.props.onRemove}
				       onMouseOver={() => this.handleMouseOver()}
				       onMouseOut={() => this.handleMouseOut()}
				       className="icon-cross removesubform"/>
				</td>
			</tr>
		)
	}
};

class DriverSubform extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			overRemove: false
		}
	}

	handleMouseOver() {
		this.setState({overRemove: true});
	}

	handleMouseOut() {
		this.setState({overRemove: false});
	}

	render() {
		return (
			<tr className={this.state.overRemove ? 'subformOverRemove' : null}>
				<td><FormField name="driver"/></td>
				<td><i title="Odstranit"
				       onClick={this.props.onRemove}
				       onMouseOver={() => this.handleMouseOver()}
				       onMouseOut={() => this.handleMouseOut()}
				       className="icon-cross removesubform"/>
				</td>
			</tr>
		)
	}
};


@connect((state, props) => {
		return {
			form: state.forms.get('tab_' + props.tabid)
		};
	},
	(dispatch) => {
		return {actions: bindActionCreators(formactions, dispatch)};
	}, null, {withRef: true})
export default class Form extends FormDB {

	constructor(props, context) {
		super(props, context);

		this.api = {
			fetch: 'invoice.fetch',
			save: 'invoice.save',
			remove: 'invoice.delete'
		};

		this.changeEvent = 'invoice.change';
		this.messages = {
			remove: 'Opravdu si přejete doklad odstranit?',
			notfound: 'Doklad nenalezena!',
			saved: 'Doklad byl uložen.'
		};

		this.schema = {
			ev: {
				class: TextInput,
				visible: false
			},
			client_type: {
				class: RadioList,
				label: 'Odběratel',
				options: DbInfo.InvoiceClientType,
				value: 2
			},
			firm: {
				class: ClientLookup,
				label: 'Firma',
				visible: (row) => {
					return row.client_type == 1
				},
			},
			driver: {
				class: DriverLookup,
				label: 'Řidič',
				visible: (row) => {
					return row.client_type == 2
				},
			},
			date1: {
				class: DatePicker,
				label: 'Datum vystavení',
				value: new moment().format('YYYY-MM-DD')
			},
			date2: {
				class: DatePicker,
				label: 'Datum splatnosti',
				placeholderText: 'UHRAZENO',
				value: new moment().add(0, 'days').format('YYYY-MM-DD')
			},
			date3: {
				class: DatePicker,
				label: 'Datum zdan. plnění',
				value: new moment().add(0, 'days').format('YYYY-MM-DD')
			},
			items: {
				class: Multiform,
				label: 'Položky',
				addLabel: 'přidat položku',
				value: [{id: -1, title: ''}],
				subform: ItemSubform,
				schema: {
					title: {
						class: TextInput,
						label: 'Popis',
						style: {width: 700}/*,
						 rules: {
						 presence: {message: 'Text je povinná položka!'},
						 length: {
						 minimum: 5,
						 message: 'Název musí být delší než 5jeden znak.'
						 }
						 }*/
					},
					amount: {
						class: Number,
						label: 'Množství',
						style: {width: 80},
					},
					price: {
						class: Number,
						label: 'Cena',
						style: {width: 80},
						addonAfter: 'Kč'
					}
				}
			},
			driversmulti: {
				class: Multiform,
				label: 'Položky',
				addLabel: 'přidat řidiče',
				showHeader: false,
				subform: DriverSubform,
				schema: {
					driver: {
						class: DriverLookup,
						clearable: false,
						styleWidth: 300,
						label: 'Řidič'
					}
				}
			},
			order: {
				class: OrderLookup,
				label: 'Objednávka'

			},
			vs: {
				class: TextInput,
				label: 'Variabilní symbol'
			},
			/*text: {
			  class: TextInput,
			  label: 'Popis'
			},
			qrmsg: {
			  class: TextInput,
			  label: 'QR zpráva'
			},*/
			status: {
				class: Select,
				options: DbInfo.InvoiceStatus.asArray(),
				value: 2,
				clearable: false,
				label: 'Stav'
			},
			notice: {
				class: TextInput,
				label: 'Poznámka'
			},
			drivers: {
				class: IconCheckbox,
				label: 'Příloha'
			},
		};
		this.form = new FormManager(this.schema);
	}

	componentDidMount() {
		this.form.on('change', (key, value) => {
			this.changed = true;
		});
		super.componentDidMount();
	}

	updateTab(data) {
		this.props.updateTab({title: data.ev});
	}

	handlePrint(type) {
		const api = new Client();
		api.call('invoice.download', {id: this.props.id, type}, {progress: true}).then((data) => {
			if (data) {
				var win = window.open(data.url, '_blank');
				if (win) {
					win.focus();
				} else {
					alert('Povolte prosím v prohlížeči vyskakovací okna pro tuto aplikaci.');
				}
				//window.location = data.url;
			}
		});
	};

	render() {

		const loading = !!(this.props.form && this.props.form.get('saving'));
		const canEdit = true || this.user.isAllowed('user', 'update');
		const canDelete = true || this.user.isAllowed('user', 'delete');
		const isNew = !this.props.id;
		const drivers = this.form.getValues().get('drivers');

		const saveCloseButton = <LoadingButton
			disabled={!canEdit}
			title="Uložit"
			loading={loading}
			onClick={() => this.save(true)}
		/>;

		const toolbar = [
			{
				title: 'Uložit',
				icon: 'fa fa-check',
				loading: loading,
				bsStyle: 'primary',
				onClick: () => this.save(true)
			},
			{
				title: 'Uložit a pokračovat v editaci',
				icon: 'fa fa-check',
				loading: loading,
				bsStyle: 'default',
				onClick: () => this.save()
			},
			{
				title: 'Uložit a nový',
				icon: 'fa fa-file-o',
				loading: loading,
				bsStyle: 'default',
				onClick: () => this.save(true, false, {}, () => this.props.newTab())
			},
			{
				divider: true
			},
			{
				title: 'Daňový doklad',
				icon: 'fa fa-file-pdf-o',
				bsStyle: 'success',
				onClick: () => this.handlePrint()
			},
			{
				divider: true
			},
			{
				title: 'Odstranit',
				icon: 'fa fa-trash-o',
				bsStyle: 'danger',
				color: '#A00',
				onClick: () => this.remove()
			}
		];

		return (
			<div style={{position: 'relative'}}>
				<Loader visible={!!(this.props.form && this.props.form.get('loading'))}/>
				<RxForm ref="form" form={this.form} id={'tab_' + this.props.tabid}>
					<Toolbar title="Daňový doklad">
						<ButtonToolbar buttons={toolbar}/>
					</Toolbar>
					<div className="row">
						<div className="col-md-8">
							<TableForm>
								<tr>
									<th>Doklad číslo</th>
									<td>
										{this.props.id > 0 && this.form.getValues().get('ev')}
										{!this.props.id && <span className="tobeadded">bude doplněno</span>}
									</td>
								</tr>
								{Object.keys(this.schema).filter(key => ['invoices', 'items', 'md_account', 'd_account', 'vs', 'order', 'status', 'driversmulti'].indexOf(key) == -1).map((key) => {
									return <FormRow key={key} visible={this.schema[key].visible} name={key}
									                labelWidth={135}/>
								})}
							</TableForm>
						</div>
						<div className="col-md-4">
							<TableForm>
								<tr>
									<th>Variabilní symbol</th>
									<td>
										{this.props.id > 0 && <FormField name="vs"/>}
										{!this.props.id && <span className="tobeadded">bude doplněno</span>}
									</td>
								</tr>
								<FormRow name="order" labelWidth={135}/>
								<FormRow name="status" labelWidth={135}/>
							</TableForm>
						</div>
						<div className="col-md-12">
							<legend style={{marginTop: 10, paddingLeft: 10, backgroundColor: '#f4f4f4'}}>Položky
							</legend>
							<FormField name="items"/>
						</div>
						{drivers &&
						<div className="col-md-12">
							<legend style={{marginTop: 10, paddingLeft: 10, backgroundColor: '#f4f4f4'}}>Příloha
							</legend>
							<FormField name="driversmulti"/>
						</div>}
					</div>
				</RxForm>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/Invoice/Form.js